import * as React from 'react';
import { useFeedbackContext } from './FeedbackContext';
import { FeedbackModal } from './FeedbackModal';

export const ContactUsFeedback: React.FC = () => {
  const { feedbackLoopEnabled, feedbackState, threadId, chatHistory, submitFeedback, closeFeedback } =
    useFeedbackContext();

  if (!feedbackLoopEnabled || !feedbackState.isOpen) {
    return null;
  }

  return (
    <FeedbackModal
      polarity={feedbackState.polarity}
      responseId={feedbackState.responseId}
      threadId={threadId}
      chatHistory={chatHistory}
      onSubmit={submitFeedback}
      onClose={closeFeedback}
    />
  );
};
